import React from 'react';
import { Box } from '@mui/material';
import {
  Page,
  Content,
} from '@backstage/core-components';
export const NotFoundPage = () => {
  return (
    <Page themeId="tool">
      <Content>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            overflowY: 'auto',
          }}
        >
        </div>
        <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="90%">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <svg width="185" height="185" viewBox="0 0 16 20" fill="#B7B7BD" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2ZM14.39 10.56C12.71 9.7 10.53 9 8 9C5.47 9 3.29 9.7 1.61 10.56C0.61 11.07 0 12.1 0 13.22V20H2V13.22C2 12.84 2.2 12.5 2.52 12.34C3.71 11.73 5.63 11 8 11C8.76 11 9.47 11.07 10.13 11.2L8.58 14.5H5.75C4.23 14.5 3 15.73 3 17.25C3 18.77 4.23 20 5.75 20H14C15.1 20 16 19.1 16 18V13.22C16 12.1 15.39 11.07 14.39 10.56ZM6.94 18H5.75C5.34 18 5 17.66 5 17.25C5 16.84 5.34 16.5 5.75 16.5H7.64L6.94 18ZM14 18H9.15L12.09 11.73C12.63 11.93 13.1 12.14 13.49 12.34C13.8 12.5 14 12.84 14 13.22V18Z" fill="#B7B7BD" />
            </svg>
            <span style={{ fontSize: '24px', marginTop: '20px', fontWeight: 700 }}>ERROR 404</span>
            <span style={{ fontSize: '16px', color: '#B7B7BD' }}>Looks like the page you are looking for is not there.</span>
          </div>
        </Box>
      </Content>
    </Page>
  );
};
